import Link from '@/components/Common/Link'
import classNames from 'classnames'
import Text from '../Common/NewText'
import React from 'react'

const SubHeaderList = ({
  list,
}: {
  list?: { label?: string; url?: string }[]
}) => {
  if (!list?.length) return null
  return (
    <div className="flex flex-row flex-wrap gap-1">
      {list?.map((item: { label?: string; url?: string }, index) => {
        if (!item.label) return null
        const jsx = (
          <Text
            appearance="caption"
            addClassName={classNames('text-brand-grey-base', {
              'underline hover:text-brand-blue-azureRadiance': item.url,
            })}
          >
            {item.label}
          </Text>
        )
        return (
          <React.Fragment key={item.label}>
            {item.url ? (
              <Link href={item.url} title={item.label}>
                {jsx}
              </Link>
            ) : (
              jsx
            )}
            {index !== list.length - 1 && (
              <Text
                appearance="caption"
                addClassName="text-brand-grey-base"
                tag="span"
                aria-hidden="true"
              >
                |
              </Text>
            )}
          </React.Fragment>
        )
      })}
    </div>
  )
}
export default SubHeaderList
